module.exports = "/images/medal.svg?c754e5fbe2ea13544853bc29ac6b4c00";


//////////////////
// WEBPACK FOOTER
// ./resources/images/icons/medal.svg
// module id = isA2
// module chunks = 0 1